import styles from "./CreateDocumentTypeKeywordsModal.module.css";
import ReactModal from "react-modal";
import Icon from "../Icon/Icon";

import { useFormik } from "formik";
import * as Yup from "yup";

type CreatePropertyModalProps = {
  isOpen: boolean;
  onRequestClose: () => void;
  onCreate: (value: string) => void;
  keywords: { value: string; id: string }[];
  deleteKeyword: (id: string) => void;
};

const CreateDocumentTypeKeywordsModal = ({
  isOpen,
  onRequestClose,
  onCreate,
  keywords,
  deleteKeyword,
}: CreatePropertyModalProps) => {
  const validationSchema = Yup.object({
    newKeyword: Yup.string()
      .trim()
      .test("unique", "Esta palabra ya ha sido añadida", function (value) {
        if (!value) return true; // если пустое — не показываем ошибку
        const trimmed = value.trim().toLowerCase();
        return !keywords.some((k) => k.value.trim().toLowerCase() === trimmed);
      }),
  });

  const formik = useFormik({
    initialValues: {
      newKeyword: "",
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      const trimmedValue = values.newKeyword.trim();
      if (trimmedValue === "") return; // не добавлять пустую строку
      onCreate(trimmedValue);
      resetForm();
    },
  });

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={styles.modal}
      overlayClassName={styles.overlay}
      ariaHideApp={false}
    >
      <h2 className={styles.title}>
        Añadir Palabras Clave <Icon name="edit-pen" size={32} />
      </h2>
      <p className={styles.subtitle}>
        Debes crear palabras clave que identifiquen el tipo de documento que se
        registrara.
      </p>
      <p className={styles.exampleText}>
        Ej. {"(Titulo del documento, departamento, órgano responsable)"}
      </p>

      <form onSubmit={formik.handleSubmit} className={styles.form}>
        {keywords.length > 0 && (
          <ul className={styles.keywordsList}>
            {keywords.map(({ id, value }) => (
              <li key={id} className={styles.keywordsListItem}>
                {value}
                <button
                  type="button"
                  className={styles.deleteKeywordIcon}
                  onClick={() => deleteKeyword(id)}
                >
                  <Icon name="x-mark" size={20} />
                </button>
              </li>
            ))}
          </ul>
        )}

        {formik.touched.newKeyword && formik.errors.newKeyword && (
          <div className={styles.textWarning}>{formik.errors.newKeyword}</div>
        )}
        <input
          id="newKeyword"
          name="newKeyword"
          type="text"
          placeholder="Palabras clave aquí"
          className={styles.input}
          value={formik.values.newKeyword}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          autoComplete="off"
        />

        <button type="submit" className={styles.createButton}>
          Añadir <Icon name="stars" size={20} />
        </button>
      </form>
      <button className={styles.closeIcon} onClick={onRequestClose}>
        <Icon name="x-mark" size={16} />
      </button>
    </ReactModal>
  );
};

export default CreateDocumentTypeKeywordsModal;
